import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../includes/ConfigFile';
import { toast } from 'react-toastify';
import { Button, Form, Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const EditChapter = () => {
  const { chapterId } = useParams();
  const navigate = useNavigate();

  const [chapterNo, setChapterNo] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    if (chapterId) {
      axios.get(`${config.BASE_URL}api/getSingleChapter/${chapterId}`)
        .then(res => {
          if (res.data.status) {
            const chapter = res.data.data;
            setChapterNo(chapter.chapter_no || '');
            setDescription(chapter.post_description || '');
          } else {
            toast.error('Chapter not found!');
          }
          setLoading(false);
        })
        .catch(err => {
          toast.error('Error loading chapter.');
          console.error(err);
          setLoading(false);
        });
    }
  }, [chapterId]);

  const handleUpdate = () => {
    if (!chapterNo.trim()) {
      toast.warn("Chapter number can't be empty!");
      return;
    }

    setUpdating(true);

    const formData = new FormData();
    formData.append('id', chapterId);
    formData.append('chapter_no', chapterNo);
    formData.append('post_description', description);

    axios.post(`${config.BASE_URL}api/updateChapter`, formData)
      .then(res => {
        if (res.data.status) {
          toast.success('Chapter updated successfully!');
          navigate(-1); // Go back
        } else {
          toast.error(res.data.message || 'Failed to update chapter');
        }
        setUpdating(false);
      })
      .catch(err => {
        toast.error('Error updating chapter');
        console.error(err);
        setUpdating(false);
      });
  };

  return (
    <div className="container my-5 p-4 bg-dark text-light rounded shadow-lg">
      <h2 className="text-center mb-4">✏️ Edit Chapter</h2>

      {loading ? (
        <div className="text-center">
          <Spinner animation="border" variant="light" />
        </div>
      ) : (
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Chapter Number</Form.Label>
            <Form.Control
              type="text"
              value={chapterNo}
              onChange={(e) => setChapterNo(e.target.value)}
              placeholder="Enter Chapter Number"
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label>Description</Form.Label>
            <div className="bg-white text-dark rounded">
              <ReactQuill
                theme="snow"
                value={description}
                onChange={setDescription}
                style={{ height: "250px" }}
              />
            </div>
          </Form.Group>

          <div className="d-flex justify-content-end mt-4">
            <Button
                variant="success"
                onClick={handleUpdate}
                disabled={updating}
                className="px-4 py-2 fw-bold rounded-3"
                style={{ minWidth: '180px' }}
            >
                {updating ? (
                <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Saving...
                </>
                ) : (
                <>💾 Update Chapter</>
                )}
            </Button>
            </div>

        </Form>
      )}
    </div>
  );
};

export default EditChapter;
